import { Suspense } from 'react'
import { Outlet } from 'react-router'

import { env } from '@/config/env'

import s from './AppLayout.module.css'
import { Rail } from './Rail'
import { Topbar } from './Topbar'

function RouteFallback() {
  return <div style={{ padding: 40, color: 'var(--ink-3)' }}>Загрузка…</div>
}

export function AppLayout() {
  return (
    <div className={s.app}>
      <Rail />
      <div className={s.main}>
        <Topbar />
        <div className={s.content}>
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </div>
        <footer className={s.footer}>
          <div className={s.footerInner}>
            <span>© QData · v{env.appVersion}</span>
          </div>
        </footer>
      </div>
    </div>
  )
}
